import {createContext, useContext} from "react";
import {MARK_UP_APPLY_TO_TYPES} from "./markUpItemInterface";

export const initialMarkUpDownValues = {
  upDownCheckboxValue: "mark_up",
  currencyPercentageCheckboxValue: "currency",
  markUpDownInputValue: 0,
  activeMarkUpItemIndex: -1,
  markUpList: [],
  applyToValue: MARK_UP_APPLY_TO_TYPES.cost,
};

const shippingSetupAction = "CHANGE_MARK_UP_DOWN_CONTEXT";

const MarkUpDownContext = createContext({});

export const useMarkUpContext = () => useContext(MarkUpDownContext);

export const markUpDownContextAction = (payload) => {
  return {
    type: shippingSetupAction,
    payload
  }
}

export const markUpDownContextReducer = (state = initialMarkUpDownValues, action) => {
  switch (action.type) {
    case shippingSetupAction:
      return {...state, ...action.payload};
    default:
      return state
  }
}

export default MarkUpDownContext;
